import { useState } from "react";
import { X } from "lucide-react";

var TEMPLATE_TYPES = [
  { value: "vencimento_boleto", label: "Vencimento Boleto" },
  { value: "vencimento_cartao", label: "Vencimento Cartao" },
  { value: "marketing", label: "Marketing" },
  { value: "custom", label: "Personalizado" },
];

export default function TemplateEditor({ template, onSave, onClose, loading }) {
  const [title, setTitle] = useState(template ? template.title : "");
  const [subject, setSubject] = useState(template ? template.subject : "");
  const [body, setBody] = useState(template ? template.body_html : "");
  const [type, setType] = useState(template ? template.template_type : "custom");
  const [error, setError] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim() || !subject.trim() || !body.trim()) return;
    setError(null);
    onSave({ title: title.trim(), subject: subject.trim(), body_html: body, template_type: type }, template ? template.id : null);
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-2xl" data-testid="template-editor-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">{template ? "Editar Template" : "Novo Template"}</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {error && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{error}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome do Template *</label>
                <input type="text" value={title} onChange={function(e) { setTitle(e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="Ex: Lembrete mensal" required data-testid="template-form-title" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Tipo</label>
                <select value={type} onChange={function(e) { setType(e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="template-form-type">
                  {TEMPLATE_TYPES.map(function(t) { return <option key={t.value} value={t.value}>{t.label}</option>; })}
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Assunto *</label>
              <input type="text" value={subject} onChange={function(e) { setSubject(e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                placeholder="Assunto do e-mail" required data-testid="template-form-subject" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Corpo HTML *</label>
              <textarea value={body} onChange={function(e) { setBody(e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm font-mono resize-none focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                rows="12" placeholder="<p>Ola, {{nome}}!</p>" required data-testid="template-form-body" />
              <p className="text-xs text-gray-400 mt-1">Variaveis: {"{{nome}}"}, {"{{descricao}}"}, {"{{valor}}"}, {"{{vencimento}}"}, {"{{metodo}}"}</p>
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loading}
                className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50"
                data-testid="template-form-submit">
                {loading ? "Salvando..." : "Salvar Template"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
